import { localizedLegalPage } from "./localized";
import { CommercialTermsPage as Fr } from "./fr/CommercialTermsPage";
import { CommercialTermsPage as En } from "./en/CommercialTermsPage";

export const CommercialTermsPage = localizedLegalPage({ fr: Fr, en: En });

export default CommercialTermsPage;
